import { Component } from '@angular/core';
import { FilterComponent } from '../filter.component';

@Component({
  selector: 'app-filter-standalone',
  templateUrl: './filter-standalone.component.html'
})
export class FilterStandAloneComponent extends FilterComponent {}
